"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearUndefined = exports.useQueryStringAsString = exports.useQueryStringAsDate = exports.useQueryStringValue = exports.useQueryString = void 0;
const query_string_1 = __importDefault(require("query-string"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const dayjs_1 = __importDefault(require("dayjs"));
const useQueryString = (options) => {
    const { search, pathname } = (0, react_router_dom_1.useLocation)();
    return (0, react_1.useMemo)(() => ({ qs: query_string_1.default.parse(search, options), pathname }), [search, options, pathname]);
};
exports.useQueryString = useQueryString;
const useQueryStringValue = (names, parse, serialize, defaultValues, validation) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { qs, pathname } = (0, exports.useQueryString)();
    const setValue = (0, react_1.useCallback)((v) => {
        const overrideObjects = names.reduce((acc, name, index) => {
            acc[name] = serialize(v[index]);
            return acc;
        }, {});
        const newQs = query_string_1.default.stringify((0, exports.clearUndefined)({ ...qs, ...overrideObjects }));
        history.pushLocalized(`${pathname}?${newQs}`);
    }, [qs, names, history.pushLocalized, serialize]);
    return (0, react_1.useMemo)(() => {
        const valuesToReturn = {};
        names.forEach((name, index) => {
            if ((!qs[name] || (validation && !validation(qs[name]))) &&
                defaultValues &&
                Boolean(defaultValues[index])) {
                valuesToReturn[name] = defaultValues[index];
            }
            else {
                // @ts-ignore
                valuesToReturn[name] = parse(qs[name]);
            }
        });
        return [valuesToReturn, setValue];
    }, [parse, qs, names, setValue, defaultValues]);
};
exports.useQueryStringValue = useQueryStringValue;
const stringParser = {
    parse: (v) => v,
    serialize: (v) => v,
};
const useQueryStringAsDate = (names, defaultValues) => {
    const dateParser = (0, react_1.useMemo)(() => ({
        parse: (v) => (0, dayjs_1.default)(v).toDate(),
        serialize: (v) => (0, dayjs_1.default)(v).toISOString(),
        validation: (v) => (0, dayjs_1.default)(v).isValid() && (0, dayjs_1.default)(v).isSameOrBefore((0, dayjs_1.default)()),
    }), []);
    return (0, exports.useQueryStringValue)(names, dateParser.parse, dateParser.serialize, defaultValues, dateParser.validation);
};
exports.useQueryStringAsDate = useQueryStringAsDate;
const useQueryStringAsString = (names, defaultValues) => {
    return (0, exports.useQueryStringValue)(names, stringParser.parse, stringParser.serialize, defaultValues);
};
exports.useQueryStringAsString = useQueryStringAsString;
const clearUndefined = (v) => Object.entries(v).reduce((acc, [key, value]) => {
    if (value !== undefined) {
        acc[key] = value;
    }
    return acc;
}, {});
exports.clearUndefined = clearUndefined;
